// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentTitleComponentFragmentDoc } from './componentTitleComponent.fragment.generated';
export const ComponentTitleFragmentDoc = gql`
    fragment componentTitle on ComponentTitle {
  __typename
  alignment
  tag
  text
  texts {
    ...componentTitleComponent
  }
  color
  titleSize
  titleStyle
  titleWidth
}
    ${ComponentTitleComponentFragmentDoc}`;